package game.entity

import game.Game
import game.Room

class Cactus(damage: Int, private val spriteId: String): Enemy(damage = damage) {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        super.onCollideWithPlayer(game, room)

        return false
    }
}